import translation from 'locales/translation';
import {
  ButtonThemes,
  CheckCircleIcon,
  Col,
  Modal,
  ModalSizes,
  Row,
  Select,
  TimesCircleIcon,
} from 'plataforma-fundacao-componentes';

import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useState } from 'react';
import { arrayCompare } from 'helpers/utils/ArrayUtils';

import './styles.scss';

interface IProps extends ModalProps {
  agency: { label: string; value: string };
  nucleou: [{ id: number; code: string }];
  nucleouOptions: [
    {
      agn: string;
      nuc: [{ id: number; code: string }];
    }
  ];
  onConfirm?: (values: { id: number; code: string }[]) => void;
}

export const EditarNucleo = (props: IProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [value, setValue] = useState<[{ id: number; code: string }]>(
    props.nucleou!
  );

  const options = props.nucleouOptions.find(
    (x: { agn: string }) => x.agn === props.agency.value
  );

  return (
    <Modal
      title={props.title}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={props.onClose}
      size={ModalSizes.Large}
      compenseColPaddingContent
      footer={[
        {
          theme: ButtonThemes.Secondary,
          leftIcon: <TimesCircleIcon />,
          children:
            translation.Assessor.Evento.Cadastro.Etapas.Entidade.Buttons
              .Cancelar,
          onClick: () => props.onClose!(props.modalKey),
        },
        {
          theme: ButtonThemes.Primary,
          leftIcon: <CheckCircleIcon />,
          children:
            translation.Assessor.Evento.Cadastro.Etapas.Entidade.Buttons
              .Confirmar,
          onClick: () => {
            setLoader(true);
            setTimeout(() => {
              setLoader(false);
              props.onClose!(props.modalKey);
              props.onConfirm && props.onConfirm(value);
            }, 750);
          },
          loading: loader,
          disabled:
            loader ||
            !value.length ||
            arrayCompare(
              props.nucleou!?.map((item) => item.id),
              value.map((item: { id: number }) => item.id)
            ),
        },
      ]}
    >
      <Row>
        <Col>
          <Select
            label={
              translation.Assessor.Evento.Cadastro.Etapas.Entidade.Campos
                .Agencia.Label
            }
            placeholder={
              translation.Assessor.Evento.Cadastro.Etapas.Entidade.Campos
                .Agencia.Placeholder
            }
            options={[
              {
                label: props.agency.label,
                value: props.agency.value,
              },
            ]}
            value={props.agency.value}
            onChange={() => {}}
            preSelectUniqueOption
            clearButton={false}
            disabled={true}
            className={'select'}
          />
        </Col>
        <Col>
          <Select
            label={
              translation.Assessor.Evento.Cadastro.Etapas.Entidade.Campos.Nucleo
                .Label
            }
            placeholder={
              translation.Assessor.Evento.Cadastro.Etapas.Entidade.Campos.Nucleo
                .Placeholder
            }
            options={
              options &&
              options.nuc
                .map((x: { id: number; code: string }) => {
                  return {
                    label: x.code,
                    value: x.id,
                  };
                })
                .sort((a: { label: string }, b: { label: string }) =>
                  a.label < b.label ? -1 : 1
                )
            }
            value={value.map((item: { id: number }) => item.id)}
            onChange={(e) => {
              setValue(
                options &&
                  (options.nuc.filter((item: { id: number }) =>
                    e.includes(item.id)
                  ) as any)
              );
            }}
            multiple
            preSelectUniqueOption
          />
        </Col>
      </Row>
    </Modal>
  );
};
